import '../Table.scss';
import { ColumnDef, flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table';

type TableProps<T> = {
    data: T[];
    columns: ColumnDef<T>[];
    className?: string;
};

export const Table = <T,>({
    data,
    columns,
    className,
}: TableProps<T>): JSX.Element => {

    const table = useReactTable({
        data: data ?? [],
        columns: columns,
        getCoreRowModel: getCoreRowModel(),
        enableRowSelection: false,
    });

    return (
        <div className="table-wrapper">
        <table className={className}>
            <thead>
                {table.getHeaderGroups().map((headerGroup, i) => {
                    return (
                        <tr className='cosem-table-tr' key={i}>
                            {headerGroup.headers.map((header) => {
                                return (
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    <th id={header.id} key={header.id} style={{width: header.column.getSize(), ...(header.column.columnDef.meta as any)?.style}}>
                                        {' '}
                                        {header.isPlaceholder
                                            ? null
                                            : flexRender(header.column.columnDef.header, header.getContext())
                                        }
                                    </th>
                                    
                                );
                            })}
                        </tr>
                    );
                })}
            </thead>
            <tbody>
                {table.getRowModel().rows.map((row) => {
                    return (
                        <tr className='cosem-table-tr' key={row.id}>
                            {row.getVisibleCells().map((cell) => {
                                return <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>;
                            })}
                        </tr>
                    );
                })}
            </tbody>
        </table>
        </div>
    );
};
